import { getObjects, createTicket, updateTicket, deleteTicket, exportObjects, exportFile_Bilan, updateTicketUser } from "../../../services/services";
import Conditions from "../../../assets/files/conditions.json";

const category_OPTIONS = [
  { label: "Support", value: "Support" },
  { label: "Issue", value: "Issue" },
  { label: "Other", value: "Other" },
];
const STATUS = [
  { label: "open", value: "open" },
  { label: "closed", value: "closed" },
];

export const ticketsConfig = {
  title: "Tickets",
  entityLabel: "Ticket",

  idField: "id",
  rowActions: [
    { key: "info", label: "Info", permission: "view_tickets", action: "info" },
    { key: "edit", label: "Edit", permission: "edit_tickets",onlyIfLessThanFiveMinutes: true, action: "edit" },
    { key: "delete", label: "Delete", permission: "delete_tickets", onlyIfLessThanFiveMinutes: true, action: "delete" },

    { key: "tomessages", label: "messages", permission: "view_messages", action: "goToMessages" },
    { key: "change_status", label: "(Admin) change status", permission: "view_profiles", action: "change_status" },
  
  ],

  actionHandlers: {
    info: ({ entity, setState, setFormParams }) => {
    setState("info");
    setFormParams([entity]);
    },
    edit: ({ entity, setState, setFormParams }) => {
      setState("edit");
      setFormParams([entity]);
    },
    delete: async ({ entity, setEntityToDelete }) => {
      setEntityToDelete(entity);
    },

    change_status: ({ entity, setState, setFormParams }) => {
      setState("change_status");
      setFormParams([entity]);
    },
    goToMessages: async ({ entity, navigate }) => {
      try {
        const res = await updateTicketUser(entity);
        navigate(`/Messages/${entity.id}/1`);
      
      } catch (e) {
        console.error(e);
      } finally {
      }
    },

  },
  
  services: {
    list: getObjects,
    create: createTicket,
    update: updateTicket,
    delete: deleteTicket,
    export: exportObjects,
    export_bilan: exportFile_Bilan,
    filters: "show",
    columns: "show",

    services_url_names: {
    list: "get_Tickets",
    create: "create_ticket",
    update: "update_ticket",
    delete: "delete_ticket",
    export: "export_Tickets",
    export_bilan: "export_tickets_bilan",
    },
  },

  attributes: [
    { label: "id", value: "id", type: "str", is_default:"true" },
    { label: "username", value: "username", type: "number", is_default:"true"},
    { label: "subject", value: "subject", type: "str" },
    { label: "description", value: "description", type: "str" },
    { label: "status", value: "status", type: "str" },
    { label: "category", value: "category", type: "str" },
    { label: "is_not_read", value: "is_not_read", type: "str", is_default:"true" },
    { label: "created_at", value: "created_at", type: "date", is_default:"true" },
    { label: "updated_at", value: "updated_at", type: "date" }, 
    { label: "message_created_at", value: "message_created_at", type: "date"}
  ],
  conditions: Conditions,

  formFields: [
    {key: "subject", label: "subject", type: "input", validation: ["required"], state: ["create", "edit", "info"] },
    {key: "category", label: "category", type: "select", SELECT_OPTIONS:category_OPTIONS, placeholder:'choose a category', validation: ["required"], state: ["create", "edit", "info"] },
    {key: "description", label: "description", type: "textarea", placeholder: "Enter description...", validation: ["required"], state: ["create", "edit", "info"] },
    {key: "status", label: "status", type: "select", SELECT_OPTIONS:STATUS, placeholder: "Enter status...", validation: ["required"], state: ["change_status"] },

  ],

  defaultFilters : [
    { attribute: "status", condition: "==", value: "open", type: "str" }, 
    { attribute: "status", condition: "==", value: "closed", type: "str" }, 
  ],

  // =========================
  // TABS CONFIG (CUSTOM PER ENTITY)
  // =========================
  tabs: [
    {
      label: "Open",
      filters: [{attribute:'status',condition:'==',value:'open',type:'str'}],   // tabIndex 1
     
    },
    {
      label: "CLosed",
      filters: [{attribute:'status',condition:'==',value:'closed',type:'str'}],   // tabIndex 2
       
    },
  ],
};
